module.exports = __webpack_public_path__ + "img/audience-segments.560d813b.png";